<section class="container">
  <ul class="nav nav-tabs mb-4">
    <li class="nav-item">
      <button class="nav-link" [class.active]="activeTab === 'standard'" (click)="setTab('standard')">
        Standard Reports
      </button>
    </li>
    <li class="nav-item">
      <button class="nav-link" [class.active]="activeTab === 'overall'" (click)="setTab('overall')">
        Overall Reports
      </button>
    </li>
  </ul>

  <!-- Standard Reports Tab -->
  <div *ngIf="activeTab === 'standard'">
    <div class="row justify-content-center">
      <div class="col-lg-8 col-md-10 col-12 text-center">
        <h1 class="reports-heading">Generate Your Report</h1>
        <p class="sub-heading">Select a report type and configure filters to download your desired data</p>

        <div class="report-selection mt-4">
          <label for="reportType" class="form-label report-label">Select Report:</label>
          <select id="reportType" class="form-select" [(ngModel)]="selectedReport" (change)="onReportChange()">
            <option *ngFor="let report of reports" [ngValue]="report">{{ report.label }}</option>
          </select>
        </div>

        <div *ngIf="selectedReport" class="mt-4">
          <h3 *ngIf="selectedReport.filters.length > 0" class="filters-heading">Filters</h3>
          <div class="filter-section">
            <ng-container *ngFor="let filter of selectedReport.filters">
              <div class="filter-group">
                <label for="{{ filter.label }}" class="form-label">{{ filter.label }}</label>
                <input
                  *ngIf="filter.type === 'date'"
                  id="{{ filter.label }}"
                  type="date"
                  class="form-control"
                  [(ngModel)]="filter.value" />
                <select
                  *ngIf="filter.type === 'select'"
                  id="{{ filter.label }}"
                  class="form-select"
                  [(ngModel)]="filter.value">
                  <option [value]="null">Select an option</option>
                  <option *ngFor="let option of filter.options" [value]="option.value">{{ option.display }}</option>
                </select>
                <tag-input *ngIf="filter.type === 'multiselect'" [(ngModel)]="filter.value">
                  <tag-input-dropdown
                    [autocompleteItems]="filter.options"
                    [showDropdownIfEmpty]="true"
                    [dynamicUpdate]="false">
                  </tag-input-dropdown>
                </tag-input>
              </div>
            </ng-container>
          </div>
        </div>

        <div class="download-button">
          <button class="btn btn-primary" (click)="downloadReport()">Download Report</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Overall Reports Tab -->
  <div *ngIf="activeTab === 'overall'">
    <div class="row justify-content-center">
      <div class="col-lg-8 col-md-10 col-12 text-center">
        <h1 class="reports-heading">Generate Overall Report</h1>
        <p class="sub-heading">Select companies, report type, and optional date range</p>

        <!-- 1. Company selector (custom dropdown) -->
        <div class="report-selection mt-4" #companyDropdownRef>
          <label class="form-label report-label">Company Groups / Entities</label>
          <div class="company-selector" (click)="toggleCompanyDropdown($event)">
            <span *ngIf="selectedCount === 0" class="company-placeholder">Select companies...</span>
            <span *ngIf="selectedCount > 0" class="company-count">
              {{ selectedCount }} {{ selectedCount === 1 ? 'company' : 'companies' }} selected
            </span>
            <span class="company-arrow">&#9660;</span>
          </div>

          <div class="company-dropdown" *ngIf="showCompanyDropdown" (click)="$event.stopPropagation()">
            <div class="company-search">
              <input
                type="text"
                placeholder="Search companies..."
                [(ngModel)]="companySearchText"
                autocomplete="off" />
            </div>

            <div class="company-actions">
              <button type="button" (click)="selectAll($event)">Select All</button>
              <span class="separator">·</span>
              <button type="button" (click)="clearAll($event)">Clear All</button>
              <span class="selection-count" *ngIf="selectedCount > 0">{{ selectedCount }} selected</span>
            </div>

            <div class="company-list">
              <label
                *ngFor="let option of filteredCompanyOptions"
                class="company-option"
                (click)="toggleCompany(option.value, $event)">
                <input
                  type="checkbox"
                  [checked]="selectedCompanyIds.has(option.value)"
                  (change)="toggleCompany(option.value, $event)"
                  (click)="$event.stopPropagation()" />
                <span>{{ option.display }}</span>
              </label>
              <div *ngIf="filteredCompanyOptions.length === 0" class="company-empty">
                No results found
              </div>
            </div>
          </div>
        </div>

        <!-- 2. Report type -->
        <div class="report-selection mt-4">
          <label for="overallReportType" class="form-label report-label">Select Report:</label>
          <select id="overallReportType" class="form-select" [(ngModel)]="selectedOverallReport" (change)="onOverallReportChange()">
            <option *ngFor="let report of overallReports" [ngValue]="report">{{ report.label }}</option>
          </select>
        </div>

        <!-- 3. Date filters (From / To side by side) -->
        <div *ngIf="selectedOverallReport" class="mt-4">
          <div class="filter-section">
            <ng-container *ngFor="let filter of selectedOverallReport.filters">
              <div *ngIf="filter.type === 'date'" class="filter-group">
                <label class="form-label">{{ filter.label }}</label>
                <input type="date" class="form-control" [(ngModel)]="filter.value" />
              </div>
            </ng-container>
          </div>
        </div>

        <div class="download-button">
          <button class="btn btn-primary" (click)="downloadOverallReport()">Download Report</button>
        </div>
      </div>
    </div>
  </div>
</section>
